import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { AppHelper } from "../../appHelper";
import { General } from "../../../siteManagement/general";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { MetaDataHelper } from "../../core/util/metaDataHelper";
import { AppBaseProps, CommonApp, Entity } from "../../core/components/commonApp";
import { Helper } from "../../core/util/helper";
import { Config } from "../../core/config/config";
import { DialogHelper } from "../../core/util/dialogHelper";
import { SheetEventType } from "../../../siteManagement/sheet";
import { EventType } from "../../../siteManagement/eventManager";
import { PageTitleProps } from "../../core/components/pageTitle";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class LevelApp extends React.Component<LevelAppProps, LevelAppState> {
    common = new AppHelper();
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    translations: StringKeyDictionary<string> = null;
    pageTitle: string;
    deleteEnabled = false;
    isDeleted = false;
    computedPageTitle = "";
    userLock: boolean = false;


    constructor(props) {
        super(props);
        this.common.init(this);
        this._refreshDeleteEnabled();

        if (!this.props.entity.IsNew) {
            const hours = Math.floor(this.props.entity.ReactionTimeMinutes / 60);
            const minutes = this.props.entity.ReactionTimeMinutes % 60;

            this.props.entity.ReactionTimeString = this._formatReactionTimeString(minutes, hours);
        }
        if (Helper.hasValue(this.props.entity.EntityUsage)) {
            this.computedPageTitle = Helper.getTranslation("WebSMS.SLA.Level.PageTitle.Copy").replace('{level}', this.props.entity.Title).replace('{agreement}', this.props.entity.AgreementTitle);;
        } else {
            this.computedPageTitle = this.translations["WebSMS.SLA.Level.TabTitle"] + (this.props.entity.IsNew ? "" : " - " + this.props.entity.Title);
        }

        General.Events.bind(EventType.SavedSuccessfully, (data: any) => {  
            if (data.context === "slaservicehours") {
                HTTPService.post("SlaServiceHours/ServiceHoursHeader?id=" + encodeURIComponent(this.props.entity.ServiceHoursId))
                    .then(data => {
                        this.props.entity.ServiceHoursTitle = data.Data.Title;
                        this.setState({});
                    });
            }
        });
    }

    private _refreshDeleteEnabled() {
        this.deleteEnabled = !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite
    }

    private _validateBusinessRules = () => {
        const errors: string[] = [];
        const entity = this.props.entity;

        if (entity.StartEvent.EventType === SlaEventType.TicketInState && !Helper.hasValue(entity.StartEvent.StatusId)) {
            errors.push(this.translations["WebSMS.SLA.ErrorStartEvent"]);
        }

        if (entity.EndEvent.EventType === SlaEventType.TicketInState && !Helper.hasValue(entity.EndEvent.StatusId)) {
            errors.push(this.translations["WebSMS.SLA.ErrorEndEvent"]);
        }

        if (entity.EndEvent.EventType === SlaEventType.TicketCreated || entity.StartEvent.EventType === SlaEventType.TicketClosed){
            errors.push(this.translations["WebSMS.SLA.ErrorInvalidStatus"]);
        }

        if (entity.StartEvent.EventType === SlaEventType.TicketInState && entity.EndEvent.EventType === SlaEventType.TicketInState && entity.StartEvent.StatusId === entity.EndEvent.StatusId) {
            errors.push(this.translations["WebSMS.SLA.ErrorSameState"]);
        }


        if (errors.length > 0) {
            NotificationHelper.showErrorMessage(errors.join("\n"));

            return false;
        }

        return true;
    }

    private _setBusinessRules = () => {
        if (this.props.entity.ReactionType === ReactionType.Reaction24_7) {
            this.props.entity.ServiceHoursId = null;
        }

        if (this.props.entity.StartEvent.EventType !== SlaEventType.TicketInState) {
            this.props.entity.StartEvent.StatusId = null;
        }

        if (this.props.entity.EndEvent.EventType !== SlaEventType.TicketInState) {
            this.props.entity.EndEvent.StatusId = null;
        }
    }

    private _formatReactionTimeString = (m: number, h: number) => {
        const minutes = Helper.isNumber(m) ? m : 0
        const hours = Helper.isNumber(h) ? h : 0;

        const hoursStr = ("   " + hours).slice(-3);
        const minutesStr = Helper.getTwoDigits(minutes);

        return hoursStr + minutesStr;
    }

    updateEventInfo = (eventInfo: EventInfo, fromInfo: EventInfo) => {
        eventInfo.EventTypeStr = fromInfo.EventTypeStr;
        eventInfo.StatusId = fromInfo.StatusId;
        eventInfo.Status = fromInfo.Status;
    }

    remove = () => {
        DialogHelper.confirm(this.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                HTTPService.post<JsonResultClass>('SlaLevel/Delete?id=' + this.props.entity.Id)
                    .then(result => {
                        if (result.Code === 0) {
                            NotificationHelper.showSuccessMessage(result.Message);
                            this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                            if (this.common.isWindow) {
                                this.common.sheetWrapper.hide();
                            } else {
                                this.deleteEnabled = false;
                                this.isDeleted = true;
                                this.props.entity.RecordRight.CanWrite = false;
                                this.setState({});
                                setTimeout(() => {
                                    window.location.href = Config.baseUrl + "DynamicSearch/SlaLevel";
                                }, 1000);
                            }
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }

    save = (closeAfterSave) => {
        if (this.common.validate() && this._validateBusinessRules()) {
            this._setBusinessRules();
            HTTPService.post<JsonResultClass<LevelEntity>>("SlaLevel/Save", this.props.entity)
                .then(result => {
                    if (result.Code === 0) {
                        if (this.props.entity.IsNew) {
                            this.props.entity.IsNew = false;
                            General.Functions.HistoryState.replaceState("SlaLevel/Edit?id=" + encodeURIComponent(this.props.entity.Id));
                        }
                        this.props.entity.ServiceHoursId = result.Data.ServiceHoursId;
                        this.props.entity.ServiceHoursTitle = result.Data.ServiceHoursTitle;
                        this.props.entity.SourceId = result.Data.SourceId;
                        this.props.entity.ReactionTypeStr = result.Data.ReactionTypeStr;

                        this.updateEventInfo(this.props.entity.StartEvent, result.Data.StartEvent);
                        this.updateEventInfo(this.props.entity.EndEvent, result.Data.EndEvent);

                        this._refreshDeleteEnabled();

                        NotificationHelper.showSuccessMessage(Config.translations.savingSuccessfulMessage);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }

                    this.common.handlePostSave(result.Code === 0, closeAfterSave);
                }, () => {

                });
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (field.model === "entity.ReactionType" && value == ReactionType.Reaction24_7) {
            this.props.entity.ServiceHoursId = null;
            this.props.entity.ServiceHoursTitle = "";
        }

        if (field.model === "entity.ServiceHoursTitle") {
            var title = Helper.hasValue(dataItem) ? (Helper.hasValue(dataItem.Title) ? dataItem.Title : dataItem.title) : "";
            var id = Helper.hasValue(dataItem) ? (Helper.hasValue(dataItem.Id) ? dataItem.Id : dataItem.id) : "";

            if (title !== value || !Helper.hasValue(value) || Helper.isStringEmpty(value)) {
                id = null;
                title = "";
                value = "";
            }

            this.props.entity.ServiceHoursId = id;
            this.props.entity.ServiceHoursTitle = title;
        }

        if (field.model === "entity.ReactionTimeString") {
            // =>  _ _ _H _ _m
            if (!Helper.isNullOrEmpty(value)) {
                const parts: string[] = value.toLowerCase().split("h");
                //does not have "H" after split
                const hoursStr = parts[0].trim();
                //still has "m" after split
                const minutesStr = parts[1].trim().substring(0, parts[1].length - 2);

                if (minutesStr.indexOf("_") !== -1) {
                    value = this.props.entity.ReactionTimeString;
                    NotificationHelper.showWarningMessage(this.translations["WebSMS.SLA.Messages.IncorrectTimeValue"]);
                } else {
                    let minutes = parseInt(minutesStr, 10);
                    let hours = parseInt(hoursStr, 10);
                    let recalculate = false;

                    if (!isFinite(minutes)) {
                        minutes = 0;
                        recalculate = true;
                    }
                    if (!isFinite(hours)) {
                        hours = 0;
                        recalculate = true;
                    }

                    if (recalculate) {
                        value = this._formatReactionTimeString(minutes, hours);
                    }

                    const totalMinutes = hours * 60 + minutes;
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.ReactionTimeMinutes", totalMinutes);
                }
            }
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    handleIsSearchFieldFullObjectModel = (field, dataItem) => {
        if (field.model === "entity.ServiceHoursTitle") {
            this.handleFieldChange(field, dataItem ? dataItem.Title : null, dataItem);
        }
    }


    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange, handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel });
        const titleProps: PageTitleProps = {
            title: this.props.title,
            value: this.props.entity.Title
        };
        return <CommonApp {...props} titleProps={titleProps} />;
    }
}

export interface LevelEntity extends Entity {
    Id: string;
    Title: string;
    Description?: string;
    ReactionTimeMinutes?: number;
    ReactionType?: ReactionType;
    ReactionTypeStr?: string;
    ServiceHoursId?: string;
    ServiceHoursTitle?: string;
    StartEvent: EventInfo;
    EndEvent: EventInfo;
    AssignmentRelated?: boolean;
    Active?: boolean
    EntityUsage: string;
    SourceId?: string;
    ReactionTimeString: string;
    AgreementTitle: string;
}

export interface LevelAppProps extends AppBaseProps {
    entity: LevelEntity
}

interface LevelAppState {

}

export interface EventInfo {
    EventType?: SlaEventType;
    EventTypeStr: string;
    StatusId?: number;
    Status: string;
}

export enum ReactionType {
    Reaction24_7 = 0,
    ReactionCustom = 1
}

export enum SlaEventType {
    TicketCreated = 0,
    TicketClosed = 1,
    TicketInState = 2,
    TechnicianOnSite = 3
}